<div (click)="showMe = !showMe" class="d-flex flex-grow justify-content-between no-select cursor-pointer">
  <h3 class="zero-text p-base-med">{{ 'user-self-service.depot.headline' | transloco }}</h3>
  <web-design-system-icon name="chevron" [class.icon-rotate]="!showMe" />
</div>

<div class="p-3" [class.d-none]="!showMe">
  <h5 class="zero-text p-small-bold mt-4 mb-2">
    {{ 'user-self-service.depot.unlocked-features' | transloco | uppercase }}
  </h5>

  <div class="row">
    <div class="col-8 zero-text">
      {{ 'user-self-service.depot.shares' | transloco }}
    </div>
    <div class="col-4 text-right">
      <span class="zero-text p-base-bold mr-2 hidden-xs">{{ 'user-self-service.depot.unlocked' | transloco }}</span>
      <web-design-system-icon name="check" color="green" />
    </div>
  </div>

  <div class="row">
    <div class="col-8 zero-text mt-2">
      {{ 'user-self-service.depot.etfs' | transloco }}
    </div>
    <div class="col-4 text-right mt-2">
      <span class="zero-text p-base-bold mr-2 hidden-xs">{{ 'user-self-service.depot.unlocked' | transloco }}</span>
      <web-design-system-icon name="check" color="green" />
    </div>
  </div>

  <div class="row">
    <div class="col-8 zero-text mt-2">
      {{ 'user-self-service.depot.derivatives' | transloco }}
      @if (customerBaseData && customerBaseData.orderCountNonLeveragedDerivatives < 10) {
        <p class="zero-text p-small-reg disabled mb-0">
          {{
            'user-self-service.depot.count'
              | transloco
                : {
                    count: customerBaseData.orderCountNonLeveragedDerivatives ? customerBaseData.orderCountNonLeveragedDerivatives : 0,
                  }
          }}
        </p>
      }
    </div>
    <div class="col-4 text-right mt-2">
      <span class="zero-text p-base-bold mr-2 hidden-xs">{{ 'user-self-service.depot.unlocked' | transloco }}</span>
      <web-design-system-icon name="check" color="green" />
    </div>
  </div>

  <div class="row">
    <div class="col-8 zero-text mt-2">
      {{ 'user-self-service.depot.leveraged' | transloco }}
      @if (customerBaseData && customerBaseData.orderCountLeveragedDerivatives < 10) {
        <p class="zero-text p-small-reg disabled mb-0">
          {{
            'user-self-service.depot.count'
              | transloco
                : {
                    count: customerBaseData.orderCountLeveragedDerivatives ? customerBaseData.orderCountLeveragedDerivatives : 0,
                  }
          }}
        </p>
      }
    </div>
    <div class="col-4 text-right mt-2">
      @if (customerBaseData?.ftgPresent) {
        <span class="zero-text p-base-bold mr-2 hidden-xs">{{ 'user-self-service.depot.unlocked' | transloco }}</span>
        <web-design-system-icon name="check" color="green" />
      } @else {
        <web-design-system-icon name="cross" color="red" />
      }
    </div>
  </div>

  @if (activateFtgAllowed$ | async) {
    <div class="mt-2">
      <self-service-activate-ftg />
    </div>
  }

  <shared-dividend-re-invest-self-service />

  <self-service-portfolio-report />
</div>
